import React from "react";

import styles from "./style.module.css";

export default class EmptyNotice extends React.PureComponent {
  render() {
    const { title, body } = this.props;

    return (
      <div className={styles.emptyWarningWrapper}>
        <div className={styles.emptyWarning}>
          <div className={styles.emptyWarningText}>
            <strong style={{ display: "block" }}>{title}</strong>
            <span>{body}</span>
          </div>
        </div>
      </div>
    );
  }
}
